module.exports = [
  require('./vampire'),
  require('./vampire_spawn'),
  require('./veteran'),
  require('./vine_blight'),
  require('./violet_fungus'),
  require('./vrock'),
  require('./vulture'),
]
